import { SVGProps, Ref, forwardRef } from 'react';

export const PrinterOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.997.5v3.553c2.583.213 2.999 1.166 2.999 4.611 0 3.446-.416 4.399-3 4.612v2.222H3v-2.222c-2.584-.213-3-1.166-3-4.612C0 5.22.416 4.266 3 4.053V.5zM4.398 1.9h7.198V4l-.267-.001H4.4zm-1.4 9.97V9.5h9.998v2.37a6 6 0 0 0 .525-.07c.478-.09.628-.208.682-.262s.171-.204.261-.682c.093-.491.13-1.182.13-2.192s-.037-1.7-.13-2.192c-.09-.478-.207-.627-.261-.681S14 5.62 13.522 5.53c-.491-.093-1.182-.131-2.192-.131H4.665c-1.01 0-1.7.038-2.192.13-.478.09-.627.208-.681.262s-.171.203-.262.681c-.092.492-.13 1.183-.13 2.192s.038 1.7.13 2.192c.09.478.207.628.262.682.054.054.203.171.681.261q.232.044.526.072m1.4-.97h7.198v3.198H4.399z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PrinterOutlinedSize16Glyph.displayName = 'PrinterOutlinedSize16Glyph';
